import { jsPDF } from "jspdf";

import { getDayName, formatDateYMD, filterData, getDeviceType } from 'scripts/common'

export const testPDF = () => {

  let doc = new jsPDF()
  doc.text("Hola mundo", 10, 10);
  return URL.createObjectURL(doc.output("blob"))
  //window.open(URL.createObjectURL(doc.output("blob")))

}

export const createPDF = (preview, logInfo, logDescription, logSample, logLab, reportDetails) => {

  if (logInfo === undefined || logInfo === [] || logInfo === null) {
    return
  } else if (logInfo.length === 0) {
    return
  }

  //console.log(`desc: ${JSON.stringify(logDescription)}`)

  let dayName = getDayName(logInfo.drillDate, true)

  let doc = new jsPDF(); // declare now to use split text function below

  doc.setProperties({
    title: `${logInfo.jobNumber} ${logInfo.location}`
  })

  //Create the PDF - Default export is a4 paper, portrait, using milimeters for units
  let xmin = 12;
  let ymin = 32;
  let xmax = 196.5; //202;
  let ymax = 282

  let ftPerPage = isNaN(logInfo.feetPerPage) ? 25 : logInfo.feetPerPage < 1 ? 25 : logInfo.feetPerPage
  let fontScale12 = 4.233 // default spacing in mm => font 12 = 4.233 mm
  let fontScale10 = 3.53 // default spacing in mm => font 10 = 3.53 mm

  let xtaskcode = xmin + 133.5; //151;
  //let xcb = xmin + 178.5; //196;
  let spacing = 7.5
  let grayRibbon = 10
  let padding = 1 // for log info text
  let descPadding = 3

  //upper vertical
  let xday = 145
  let xspacing = (xmax-xmin)/4
  let imgData;
  let yMinUpperInfo = ymin+grayRibbon;

  let drawHeightMin = yMinUpperInfo + spacing * 4
  let drawHeight = ymax - drawHeightMin

  let descriptionHeader = yMinUpperInfo + spacing * 3

  let drawWidth = xmax - xmin

  let descHorzSpacing = 12
  let descHorzSpacing2 = 5
  let descSpacing = drawWidth - descHorzSpacing * 6 - descHorzSpacing2 * 3

  let trimStr; // this is used to trim some str which are too long to fit in the space given

  imgData = 'data:image/png;base64,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';

  doc.setFont('times', 'normal')
  doc.setFontSize(12)

  let pages = 1
  let currPage = 1
  let currStartDepth = 0
  let currEndDepth = currStartDepth + ftPerPage
  let mmPerFoot = drawHeight / ftPerPage

  // draw graphics and descriptions

  let prevLineStyle = ''
  //let prevInitial = 0
  let prevFinal = 0
  let prevTop = 0
  let prevBottom = 0
  let prevDesc = ''

  for (let i = 0; i < logDescription.length; i++) {

    let txt = ''

    //console.log(`test: ${JSON.stringify(logDescription[i])}`)

    let initialDepth = parseFloat(logDescription[i].initialDepth)  // a string or '' return Nan !!
    let finalDepth = parseFloat(logDescription.[i].finalDepth) // a string or '' return Nan !!

    //console.log(`initialDepth: ${initialDepth}`)

    // determine if final depth section spans beyond current page

    let spannedPages = 0 // if the finalDepth spans a second page, then loop description/graphic again

    if (finalDepth >= currEndDepth) {

      let diff = (finalDepth - currEndDepth)
      spannedPages = Math.ceil(diff / ftPerPage)

    }

    //console.log(`spannedPages: ${ spannedPages}`)

    for (let k = 0; k <= spannedPages; k++) {

      // console.log(`
      //   spannedPages: ${spannedPages}
      //   k: ${k}
      //   finalDepth: ${finalDepth}
      //   currEndDepth: ${currEndDepth}
      // `)

      if (spannedPages > 0 && k === 0) {

        //console.log('addPage')
        //doc.addPage()
        //currPage += 1
        //pages += 1
        //currStartDepth = (currPage - 1) * ftPerPage
        //currEndDepth = currStartDepth + ftPerPage

        //initialDepth = parseFloat(logDescription[i].initialDepth)  // a string or '' return Nan !!
        //finalDepth = parseFloat(logDescription.[i].finalDepth) // a string or '' return Nan !!

        finalDepth = currEndDepth

        prevFinal = prevFinal - mmPerFoot * ftPerPage
        prevBottom = prevBottom - mmPerFoot * ftPerPage

      } else if (spannedPages > 0 && k !== spannedPages) {

        doc.addPage()
        currPage += 1
        pages += 1
        currStartDepth = (currPage - 1) * ftPerPage
        currEndDepth = currStartDepth + ftPerPage

        initialDepth = currStartDepth
        finalDepth = currEndDepth

        prevFinal = prevFinal - mmPerFoot * ftPerPage
        prevBottom = 0

      } else if (spannedPages > 0 && k === spannedPages) {

        doc.addPage()
        currPage += 1
        pages += 1
        currStartDepth = (currPage - 1) * ftPerPage
        currEndDepth = currStartDepth + ftPerPage

        initialDepth = currStartDepth
        finalDepth = parseFloat(logDescription.[i].finalDepth)

        prevFinal = prevFinal - mmPerFoot * ftPerPage
        prevBottom = 0

      } else if (initialDepth >= currEndDepth) {
        //console.log('addPage')
        doc.addPage()
        currPage += 1
        pages += 1
        currStartDepth = (currPage - 1) * ftPerPage
        currEndDepth = currStartDepth + ftPerPage

        prevFinal = prevFinal - mmPerFoot * ftPerPage
        prevBottom = prevBottom - mmPerFoot * ftPerPage

      }

      let initial = mmPerFoot * (initialDepth - currStartDepth)
      let final = mmPerFoot * (finalDepth > currEndDepth ? currEndDepth : finalDepth - currStartDepth)

      let positionTop = initial > prevBottom ? initial : prevBottom

      let positionBottom

      // alright lets do the graphics

      if (logDescription[i].initialDepth !== '' && logDescription[i].finalDepth !== '') {        

        // draw graphic
        //let cobble = 10
        let gravel = 3
        let sand = 8
        let silt = 4
        let clay = 10

        // asphalt graphic

        if (filterData(logDescription[i].description, 'asphalt')) {

          //doc.setFillColor(220, 220, 220)
          doc.rect(xmin + descHorzSpacing, drawHeightMin + initial, descHorzSpacing, final - initial, 'F')
          doc.setFillColor(0, 0, 0)

        }

        // concrete graphic

        if (filterData(logDescription[i].description, 'concrete')) {

          doc.setFillColor(220, 220, 220)
          doc.rect(xmin + descHorzSpacing, drawHeightMin + initial, descHorzSpacing, final - initial, 'F')
          doc.setFillColor(0, 0, 0)

        }

        // clay graphic

        if (filterData(logDescription[i].description, 'clay')) {

          doc.setFillColor(220, 220, 220)
          doc.rect(xmin + descHorzSpacing, drawHeightMin + initial, descHorzSpacing, final - initial, 'F')
          doc.setFillColor(0, 0, 0)

        }

        // silt graphic

        if (filterData(logDescription[i].description, 'silt')) {

          for (let j = 0; j < silt; j++) {

            let inc = descHorzSpacing / silt * j

            doc.line(xmin + descHorzSpacing + inc, drawHeightMin + initial, xmin + descHorzSpacing + inc, drawHeightMin + final)

          }

        }

        // sand graphic        

        if (filterData(logDescription[i].description, 'sand')) {

          let sandRows = (finalDepth - initialDepth) * sand

          for (let j = 0; j < sandRows; j++) {

            //let incX = descHorzSpacing / sand * j
            let inc = mmPerFoot * (finalDepth - initialDepth) / sandRows * j
            //let random = Math.floor(Math.random() * sand)

            for (let k = 0; k < 5; k++) {

              let random = Math.floor(Math.random() * descHorzSpacing)

              doc.circle(xmin + descHorzSpacing + random, drawHeightMin + initial + inc, 0.1, 'F')

            }

            //doc.circle(xmin + descHorzSpacing + random, drawHeightMin + initial + random, 1)

            //doc.line(xmin + descHorzSpacing + inc, drawHeightMin + initial, xmin + descHorzSpacing + inc, drawHeightMin + final)

          }

        }

        // gravel and base graphic

        if (filterData(logDescription[i].description, 'gravel') || filterData(logDescription[i].description, 'base')) {

          let gravelRows = (finalDepth - initialDepth) * 0.85 //* gravel

          for (let j = 0; j < gravelRows; j++) {

            for (let k = 0; k < 4; k++) {

              let minY = 0.5 // line width // * mmPerFoot * (finalDepth - initialDepth)
              let maxY = mmPerFoot * (finalDepth - initialDepth)

              let randomY = Math.floor(Math.random() * (maxY - minY) + minY) // min inclusive and max exclusive

              let inc = randomY // mmPerFoot * (finalDepth - initialDepth) / gravelRows * j

              let min = 0.1 * descHorzSpacing
              let max = descHorzSpacing

              let random = Math.floor(Math.random() * (max - min) + min) // min inclusive and max exclusive

              // Math.floor(Math.random() * (max - min + 1) + min) // min and max inclusive

              doc.circle(xmin + descHorzSpacing + random, drawHeightMin + initial + inc, 0.5, 'F')

            }

            //doc.circle(xmin + descHorzSpacing + random, drawHeightMin + initial + random, 1)

            //doc.line(xmin + descHorzSpacing + inc, drawHeightMin + initial, xmin + descHorzSpacing + inc, drawHeightMin + final)

          }

        }

      }

      // Alright description time

      if (k === 0 ) {

        //if (k === 0) {

          let descLowerCase = logDescription[i].description.toLowerCase()

          if (
            filterData(logDescription[i].additionalDescription, 'total depth') ||
            filterData(logDescription[i].additionalDescription, 'end of boring') ||
            (logInfo.depth === logDescription[i].initialDepth)
          ) {
            // do nothing
          } else if (logDescription[i].finalDepth === '') {
            txt += `@ ${logDescription[i].initialDepth} ft, `
          }

          if (logDescription[i].layer !== '') {txt += `${logDescription[i].layer}\n`}

          if (
            filterData(logDescription[i].description, 'asphalt') ||
            filterData(logDescription[i].description, 'base') ||
            filterData(logDescription[i].description, 'concrete')
          ) {
            txt += `${logDescription[i].description} `
          } else if (logDescription[i].description !== '' && logDescription[i].uscs !== '') {
            txt += `${logDescription[i].description} (${logDescription[i].uscs}): `
          } else if (logDescription[i].description !== '') {
            txt += `${logDescription[i].description}: `
          }

          if (logDescription[i].color !== '') {txt += `${logDescription[i].color}, `}
          if (logDescription[i].additionalColor !== '') {txt += `${logDescription[i].additionalColor}, `}
          if (logDescription[i].moisture !== '') {txt += `${logDescription[i].moisture}, `}
          if (logDescription[i].density !== '') {txt += `${logDescription[i].density}, `}
          if (logDescription[i].grainSize !== '') {txt += `${logDescription[i].grainSize}, `}
          if (logDescription[i].additionalDescription !== '') {txt += `${logDescription[i].additionalDescription}`}

          txt = txt.trim()
          if (txt.charAt(txt.length-1) === ',') {txt = txt.slice(0, -1)}

          txt = doc.splitTextToSize(txt, descSpacing - descPadding * 2) //wraps text within specified space, does not account for y axis

        //}

        positionBottom = positionTop + descPadding + (txt.length * fontScale12) // default spacing in mm => font 12 = 4.233 mm

        // will description fit in the remaining space?

        if (positionBottom >= mmPerFoot * ftPerPage) {

          let diff = mmPerFoot * ftPerPage - positionTop

          let maxLines = Math.floor(diff / fontScale12)

          if (maxLines > 0) {

            let x = xmin + descHorzSpacing * 2 + descPadding
            let y = drawHeightMin + positionTop + 4.25

            if (logDescription[i].layer !== '') {

              doc.setFont('times', 'bold')
              doc.text(x, y, logDescription[i].layer)
              let textWidth = doc.getTextWidth(logDescription[i].layer);
              doc.line(x, y + 0.5, x + textWidth, y + 0.5)
              doc.setFont('times', 'normal')
              doc.text(x, y + fontScale12, txt.slice(1))

            } else {

              doc.text(x, y, txt)

            }

            //   doc.text( xmin + margin, ymin + margin + grayRibbon + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
            txt.splice(0, maxLines) // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc

          }

        } else {

          let x = xmin + descHorzSpacing * 2 + descPadding
          let y = drawHeightMin + positionTop + 4.25

          if (logDescription[i].layer !== '') {

            doc.setFont('times', 'bold')
            doc.text(x, y, logDescription[i].layer)
            let textWidth = doc.getTextWidth(logDescription[i].layer);
            doc.line(x, y + 0.5, x + textWidth, y + 0.5)
            doc.setFont('times', 'normal')
            doc.text(x, y + fontScale12, txt.slice(1))

          } else {

            doc.text(x, y, txt)

          }

        }

      } else if (spannedPages > 0) {

        positionBottom = positionTop + descPadding + (txt.length * fontScale12) // default spacing in mm => font 12 = 4.233 mm

        // will description fit in the remaining space?

        if (positionBottom >= mmPerFoot * ftPerPage) {

          let diff = mmPerFoot * ftPerPage - positionTop

          let maxLines = Math.floor(diff / fontScale12)

          if (maxLines > 0) {

            let x = xmin + descHorzSpacing * 2 + descPadding
            let y = drawHeightMin + positionTop + 4.25

            if (logDescription[i].layer !== '') {

              doc.setFont('times', 'bold')
              doc.text(x, y, logDescription[i].layer)
              let textWidth = doc.getTextWidth(logDescription[i].layer);
              doc.line(x, y + 0.5, x + textWidth, y + 0.5)
              doc.setFont('times', 'normal')
              doc.text(x, y + fontScale12, txt.slice(1))

            } else {

              doc.text(x, y, txt)

            }

            //   doc.text( xmin + margin, ymin + margin + grayRibbon + spacing * 6 - 4.25, description.slice( 0, maxLines )); //print each page's content
            txt.splice(0, maxLines) // now remove printed lines --> notice its s'P'lice and not slice. no need for description = des..etc

          }

        } else {

          let x = xmin + descHorzSpacing * 2 + descPadding
          let y = drawHeightMin + positionTop + 4.25

          if (logDescription[i].layer !== '') {

            doc.setFont('times', 'bold')
            doc.text(x, y, logDescription[i].layer)
            let textWidth = doc.getTextWidth(logDescription[i].layer);
            doc.line(x, y + 0.5, x + textWidth, y + 0.5)
            doc.setFont('times', 'normal')
            doc.text(x, y + fontScale12, txt.slice(1))

          } else {

            doc.text(x, y, txt)

          }

        }

      }

      // maybe sloppy, but draw bottom line when next finalDepth is found or final record

      if (prevFinal !== 0 && prevBottom !== 0 && (logDescription[i].finalDepth !== '' || i === logDescription.length - 1)) {

        let bottom = initial > prevBottom ? initial : prevBottom

        if (prevLineStyle === 'Dash') {
          doc.setLineDashPattern([1,1], 0)
        }

        // draw final depth for graphic

        doc.line(xmin + descHorzSpacing, drawHeightMin + initial, xmin + descHorzSpacing * 2, drawHeightMin + initial)

        // draw final depth for desc

        doc.line(xmin + descHorzSpacing * 2, drawHeightMin + initial, xmin + descHorzSpacing * 2 + descPadding, drawHeightMin + bottom)

        doc.line(xmin + descHorzSpacing * 2 + descPadding, drawHeightMin + bottom, xmin + descHorzSpacing * 2 + descSpacing - descPadding, drawHeightMin + bottom)

        doc.line(xmin + descHorzSpacing * 2 + descSpacing - descPadding, drawHeightMin + bottom, xmin + descHorzSpacing * 2 + descSpacing, drawHeightMin + initial)

        doc.setLineDashPattern([], 0)

      }

      if (logDescription[i].finalDepth !== '') {
        prevFinal = final
        prevLineStyle = logDescription[i].lineStyle
      }

      prevTop = positionTop
      prevBottom = positionBottom

    }

  }

  // draw samples

  currPage = 1
  currStartDepth = 0
  currEndDepth = currStartDepth + ftPerPage
  doc.setPage(currPage)

  for (let i = 0; i < logSample.length; i++) {

    //console.log(`test: ${JSON.stringify(logDescription[i])}`)

    if (logSample[i].depth >= currEndDepth) {

      currPage += 1
      doc.setPage(currPage)

      currStartDepth = (currPage - 1) * ftPerPage
      currEndDepth = currStartDepth + ftPerPage

    }

    let depth = mmPerFoot * (logSample[i].depth - currStartDepth)
    let sampleLength = mmPerFoot * logSample[i].sampleLength

    if (logSample[i].depth !== '') {

      let x = xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2
      let y = drawHeightMin + depth

      switch (logSample[i].type) {
        case 'CA':
        case 'ca':

          doc.setFillColor(128, 128, 128);
          doc.rect(x, y, descHorzSpacing2, sampleLength, 'F')

          //black
          doc.setDrawColor(0, 0, 0)

          break;
        case 'SPT':
        case 'spt':

          doc.setFillColor(128, 128, 128);
          //doc.rect(xmin + descHorzSpacing * 2 + descSpacing +descHorzSpacing2, drawHeightMin + depth, descHorzSpacing2, sampleLength, 'F')

          doc.triangle(x, y, x + descHorzSpacing2, y, x + descHorzSpacing2 / 2, y + sampleLength / 2, 'F') // top
          doc.triangle(x, y + sampleLength, x + descHorzSpacing2, y + sampleLength, x + descHorzSpacing2 / 2, y + sampleLength / 2, 'F') // bottom

          //black
          doc.setDrawColor(0, 0, 0)

          break;
        case 'SHELBY':
        case 'shelby':

          doc.setFillColor(128, 128, 128);
          doc.line(x + descHorzSpacing2 * 0.25, y, x + descHorzSpacing2 * 0.25, y + sampleLength)
          doc.line(x + descHorzSpacing2 * 0.5, y, x + descHorzSpacing2 * 0.5, y + sampleLength)
          doc.line(x + descHorzSpacing2 * 0.75, y, x + descHorzSpacing2 * 0.75, y + sampleLength)

          //black
          doc.setDrawColor(0, 0, 0)

          break;
        case 'BULK':
        case 'bulk':

          doc.setFillColor(128, 128, 128);
          //doc.setLineWidth(0.5)
          doc.rect(xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 * 2, drawHeightMin + depth, descHorzSpacing2, sampleLength, 'F')

          //black
          doc.setDrawColor(0, 0, 0)

          break;
        case 'smbag':

          doc.setFillColor(0, 0, 0);
          //doc.setLineWidth(0.5)
          doc.rect(xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 * 2, drawHeightMin + depth, descHorzSpacing2, sampleLength, 'F')

          //black
          doc.setDrawColor(0, 0, 0)

          break;
        default:
          console.log(`no sample`);
      }

      //black
      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.25)

      // add blow counts

      if (logSample[i].type.toLowerCase() === 'ca' || logSample[i].type.toLowerCase() === 'spt') {

        let bc = ''

        if (logSample[i].blowCount4 !== '' && logSample[i].blowCount3 !== '') {

          bc = Number(logSample[i].blowCount4) + Number(logSample[i].blowCount3)

        } else if (logSample[i].blowCount3 !== '' && logSample[i].blowCount2 !== '') {

          bc = Number(logSample[i].blowCount3) + Number(logSample[i].blowCount2)

        } else if (logSample[i].blowCount2 !== '' && logSample[i].blowCount1 !== '') {

          bc = Number(logSample[i].blowCount2) + Number(logSample[i].blowCount1)

        } else if (logSample[i].blowCount1 !== '') {

          bc = logSample[i].blowCount1

        }

        let sampleLength2 = Number(logSample[i].sampleLength)

        switch (sampleLength2) {
          case 0.5:
            bc += '/\n6"'
            break;
          case 1:
            break;
          case 1.5:
            break;
          case 2:
            break;
          default:

            if (sampleLength2 % 1 !== 0 && parseFloat(sampleLength2) > 1) {

              let num = Math.round((parseFloat(sampleLength2 % 1) * 12 + 6) * 10) / 10 // convert to inches and add 6 inches, the place round to one decimal place
              bc += `/\n${num}"`

            } else if (sampleLength2 % 1 !== 0) {

              let num = Math.round(parseFloat(sampleLength2 % 1) * 12 * 10) / 10 // convert to inches, the place round to one decimal place
              bc += `/\n${num}"`

            }
        }

        doc.text(xmin + descHorzSpacing * 2 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + depth + fontScale12, String(bc), 'center')

        // recovered??

        // console.log(`
        //   location: ${logSample[i].location}
        //   depth: ${logSample[i].depth}
        //   recovered: ${logSample[i].recovered}
        //   `)

        if (logSample[i].recovered === 0) {

          doc.setFontSize(10)

          doc.text(xmin + descHorzSpacing * 4 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + depth + fontScale10, 'no\nrecover', 'center')

          doc.setFontSize(12)

        }

      }

    }

  }

  // draw mds

  currPage = 1
  currStartDepth = 0
  currEndDepth = currStartDepth + ftPerPage
  doc.setPage(currPage)

  for (let i = 0; i < logLab.length; i++) {

    //console.log(`logLab: ${JSON.stringify(logLab[i])}`)

    if (logLab[i].depth >= currEndDepth) {

      currPage += 1
      doc.setPage(currPage)

      currStartDepth = (currPage - 1) * ftPerPage
      currEndDepth = currStartDepth + ftPerPage

    }

    if (logLab[i].depth !== '' && logLab[i].depth !== null) {

      // the split remove a '-' ie 0-5

      let depth = mmPerFoot * (Number(logLab[i].depth.split('-')[0]) - currStartDepth)

      // add mds

      if (logLab[i].statusmds !== null && logLab[i].statusmds !== '' && logLab[i].statusmds !== 'notRun') {

        let avgRingWt = logLab[i].sampletype === 'ca' ? 45 : 71 // 71 for shelbies
        let ringFactor = logLab[i].sampletype === 'ca' ? 0.828 : 0.587 // for shelbies
        let sg = 2.7
        let wtOfRings = avgRingWt * Number(logLab[i].ringno)
        let wtOfSoil = Number(logLab[i].wetsoilandringwt) - wtOfRings
        let wetDensity = Math.round(10*(wtOfSoil * ringFactor)/Number(logLab[i].ringno))/10

        let wtOfWater = Number(logLab[i].wetsoilandtarewt) - Number(logLab[i].drysoilandtarewt)
        let wtOfDrySoil = Number(logLab[i].drysoilandtarewt) - Number(logLab[i].tarewt)
        let moistureContent = Math.round(10*wtOfWater/wtOfDrySoil*100)/10
        let dryDensity = Math.round(10*wetDensity/(1+(moistureContent/100)))/10
        let saturation = Math.round(10*(moistureContent/((62.4/dryDensity)-(1/sg))))/10

        moistureContent = moistureContent === null || isNaN(moistureContent) ? '' : moistureContent
        dryDensity = dryDensity === null || isNaN(dryDensity) ? '' : dryDensity

        // let txt = ``
        // txt += dryDensity !== '' && dryDensity !== null ? `${dryDensity}pcf`
        // txt += moistureContent !== '' && moistureContent !== null ? `${moistureContent}%`
        // console.log(`status: ${logLab[i].statusmds}`)
        // console.log(`wtOfRings: ${wtOfRings}`)
        // console.log(`wetsoilandringWt: ${logLab[i].wetsoilandringWt}`)
        // console.log(`ringFactor: ${ringFactor}`)
        // console.log(`ringno: ${logLab[i].ringno}`)
        // console.log(`wtOfSoil: ${wtOfSoil}`)
        // console.log(`wetDensity: ${wetDensity}`)
        // console.log(`dryDensity: ${dryDensity}`)

        doc.text(String(moistureContent), xmin + descHorzSpacing * 3 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + depth + fontScale12, 'center')

        if (logLab[i].disturbed === 'Yes') {

          doc.setFontSize(10)

          doc.text(xmin + descHorzSpacing * 4 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + depth + fontScale10, 'disturb', 'center')

          doc.setFontSize(12)

        } else {

          doc.text(String(dryDensity), xmin + descHorzSpacing * 4 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + depth + fontScale12, 'center')

        }

      }

      // add lab run

      let txt = ''

      let statuses = ['statusmax', 'statusei', 'statusso4', 'statusconsol', 'statussa', 'statushydro', 'status200', 'statusatt', 'statusph', 'statusresist', 'statusch', 'statusrval', 'statusse', 'statussval', 'statusoc', 'statusacsa', 'statusav']

      for (let j = 0; j < statuses.length; j++) {

        if (logLab[i][statuses[j]] !== null && logLab[i][statuses[j]] !== '' && logLab[i][statuses[j]] !== 'notRun' ) txt += ` ${statuses[j].replace('status','')}`

      }

      txt = txt.trim()
      let x = xmin + descHorzSpacing * 5 + descHorzSpacing / 2 + descSpacing + descHorzSpacing2 * 3
      let y = Number(drawHeightMin) + Number(depth) + Number(fontScale10)

      // console.log(`
      //   txt ${txt}
      //   x ${x}
      //   y ${y}
      //   drawHeightMin ${drawHeightMin}
      //   depth ${depth}
      //   fontScale12 ${fontScale12}
      //   logLab[i].depth ${Number(logLab[i].depth.split('-')[0])}
      // `)

      txt = doc.splitTextToSize(txt, descHorzSpacing - 2) //wraps text within specified space, does not account for y axis

      doc.setFontSize(10)
      doc.text(txt, x, y, 'center')

    }

  }

  for (let i = 1; i < pages + 1; i++) {

    doc.setPage(i)

    // add AKA logo
    doc.addImage(imgData, 'JPEG', 46, 15, 116, 15)

    //black
    doc.setDrawColor(0, 0, 0);

    //outside frame
    doc.setLineWidth(1);
    doc.line(xmin, ymin, xmax, ymin); // horizontal top
    doc.line(xmin, ymin, xmin, ymax); // vertical left
    doc.line(xmin, ymax, xmax, ymax); // horizontal bottom
    doc.line(xmax, ymin, xmax, ymax); // vertical right

    //upper horizontal
    doc.setLineWidth(0.5);


    doc.setLineWidth(1);
    doc.line(xmin, ymin+grayRibbon, xmax, ymin+grayRibbon);
    doc.setLineWidth(0.5);
    doc.line(xmin, yMinUpperInfo+spacing*3, xmax, yMinUpperInfo+spacing*3);
    //doc.line(xmin, yMinUpperInfo+spacing*5, xmax, yMinUpperInfo+spacing*5);
    doc.setLineWidth(0.25);
    doc.line(xmin, yMinUpperInfo+spacing, xmax, yMinUpperInfo+spacing);
    doc.line(xmin, yMinUpperInfo+spacing*2, xmax, yMinUpperInfo+spacing*2);
    doc.line(xmin, drawHeightMin, xmax, drawHeightMin) // headers for description space

    doc.setLineWidth(0.5)

    //start text
    doc.setFont('times', 'bold');
    //doc.setFontType('bold');
    doc.setFontSize(14)

    // gray header
    doc.setFillColor(220, 220, 220);
    doc.rect(xmin, ymin, xmax-xmin, ymin+grayRibbon-ymin, 'F');

    //black
    doc.setDrawColor(0, 0, 0);

    doc.text(xmin + xspacing*2, ymin+grayRibbon/2+1, `EXPLORATION LOG ${logInfo.location}`, 'center');

    doc.setLineWidth(0.25);

    doc.setFontSize(8);

    doc.text(xmin + padding, ymin+grayRibbon+spacing-4.25, 'JOB NO.');

    doc.text(xmin + xspacing/2+1, ymin+grayRibbon+spacing-4.25, 'CLIENT/PROJECT');

    doc.text(xday+1, ymin+grayRibbon+spacing-4.25, 'DAY');

    doc.text((xmax-xday)/2+xday+1, ymin+grayRibbon+spacing-4.25, 'DATE');

    doc.text(xmin + padding, ymin+grayRibbon+spacing*2-4.25, 'LOCATION');

    doc.text(xmin + xspacing*2+1, ymin+grayRibbon+spacing*2-4.25, 'LATITUDE');

    doc.text(xmin + xspacing*2.66+1, ymin+grayRibbon+spacing*2-4.25, 'LONGITUDE');

    doc.text(xmin + xspacing*3.33+1, ymin+grayRibbon+spacing*2-4.25, 'ELEVATION');

    doc.text(xmin + padding, ymin+grayRibbon+spacing*3-4.25, 'LOGGED BY');

    doc.text(xmin + xspacing*1+1, ymin+grayRibbon+spacing*3-4.25, 'DRILLER');

    doc.text(xmin + xspacing*2+1, ymin+grayRibbon+spacing*3-4.25, 'DRILL METHOD');

    doc.text(xmin + xspacing*3+1, ymin+grayRibbon+spacing*3-4.25, 'DRIVING WEIGHT')

    // text headers for description space

    doc.text(xmin + padding, ymin+grayRibbon+spacing*4-4.25, 'DEPTH')
    doc.text(xmin + padding + descHorzSpacing, ymin+grayRibbon+spacing*4-4.25, 'LITHO')
    doc.text(xmin + padding + descHorzSpacing * 2, ymin+grayRibbon+spacing*4-4.25, 'DESCRIPTION')

    doc.text(xmin + padding + descHorzSpacing * 2 + descSpacing, ymin+grayRibbon+spacing*4-7, 'H2O', null, 270)
    doc.text(xmin + padding + descHorzSpacing * 2 + descSpacing + descHorzSpacing2, ymin+grayRibbon+spacing*4-7, 'COR', null, 270)
    doc.text(xmin + padding + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 * 2, ymin+grayRibbon+spacing*4-7, 'BAG', null, 270)

    doc.text(xmin + padding + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 * 3, ymin+grayRibbon+spacing*4-4.25, 'BLOW\nCOUNT')
    doc.text(xmin + padding + descHorzSpacing * 3 + descSpacing + descHorzSpacing2 * 3, ymin+grayRibbon+spacing*4-4.25, 'MC\n(%)')
    doc.text(xmin + padding + descHorzSpacing * 4 + descSpacing + descHorzSpacing2 * 3, ymin+grayRibbon+spacing*4-4.25, 'DD\n(pcf)')
    doc.text(xmin + padding + descHorzSpacing * 5 + descSpacing + descHorzSpacing2 * 3, ymin+grayRibbon+spacing*4-4.25, 'LAB')

    doc.line(xday, ymin+grayRibbon, xday, ymin+grayRibbon+spacing); //day
    doc.line((xmax-xday)/2+xday, ymin+grayRibbon, (xmax-xday)/2+xday, ymin+grayRibbon+spacing); //date
    doc.line(xmin + xspacing/2, ymin+grayRibbon, xmin + xspacing/2, ymin+grayRibbon+spacing); //client
    doc.line(xmin + xspacing*2, ymin+grayRibbon+spacing, xmin + xspacing*2, ymin+grayRibbon+spacing*2); //project

    doc.line(xmin + xspacing*2.66, ymin+grayRibbon+spacing, xmin + xspacing*2.66, ymin+grayRibbon+spacing*2); //yardage today
    doc.line(xmin + xspacing*3.33, ymin+grayRibbon+spacing, xmin + xspacing*3.33, ymin+grayRibbon+spacing*2); //yardage today

    doc.line(xmin + xspacing, ymin+grayRibbon+spacing*2, xmin + xspacing, ymin+grayRibbon+spacing*3); //foreman
    doc.line(xmin + xspacing*2, ymin+grayRibbon+spacing*2, xmin + xspacing*2, ymin+grayRibbon+spacing*3); //weather
    doc.line(xmin + xspacing*3, ymin+grayRibbon+spacing*2, xmin + xspacing*3, ymin+grayRibbon+spacing*3); //yardage to date

    //create description space
    // draw depth tick marks for 'Depth' and 'core/bulk'

    doc.setLineWidth(0.25)
    doc.setFontSize(10)

    for (let j = 1; j < ftPerPage; j++) {

      let increment = mmPerFoot * j
      let text = String(j + (ftPerPage * (i-1)))

      //console.log(`drawheight: ${drawHeight} : ${increment}`)

      // Depth

      doc.line(xmin + 3, drawHeightMin + increment, xmin, drawHeightMin + increment)
      doc.text(text, xmin + descHorzSpacing / 2, drawHeightMin + increment + 1, 'center')
      doc.line(xmin + descHorzSpacing - 3, drawHeightMin + increment, xmin + descHorzSpacing, drawHeightMin + increment)

      // Core / Depth

      doc.line(xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2, drawHeightMin + increment, xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 * 3, drawHeightMin + increment)

    }

    // depth right horz line
    doc.line(xmin + descHorzSpacing, spacing + descriptionHeader + drawHeight, xmin + descHorzSpacing, descriptionHeader)

    // litho right horz line
    doc.line(xmin + descHorzSpacing * 2, spacing + descriptionHeader + drawHeight, xmin + descHorzSpacing * 2, descriptionHeader)

    // other tests left horz line
    doc.line(xmax - descHorzSpacing, spacing + descriptionHeader + drawHeight, xmax - descHorzSpacing, descriptionHeader)

    // dry dens left horz line
    doc.line(xmax - descHorzSpacing * 2, spacing + descriptionHeader + drawHeight, xmax - descHorzSpacing * 2, descriptionHeader)

    // moist left horz line
    doc.line(xmax - descHorzSpacing * 3, spacing + descriptionHeader + drawHeight, xmax - descHorzSpacing * 3, descriptionHeader)

    // blow count left horz line
    doc.line(xmax - descHorzSpacing * 4, spacing + descriptionHeader + drawHeight, xmax - descHorzSpacing * 4, descriptionHeader)

    // bulk left horz line
    doc.line(xmax - (descHorzSpacing * 4) - descHorzSpacing2, spacing + descriptionHeader + drawHeight, xmax - (descHorzSpacing * 4) - descHorzSpacing2, descriptionHeader)

    // core left horz line
    doc.line(xmax - (descHorzSpacing * 4) - descHorzSpacing2 * 2, spacing + descriptionHeader + drawHeight, xmax - (descHorzSpacing * 4) - descHorzSpacing2 * 2, descriptionHeader)

    // water left horz line
    doc.line(xmax - (descHorzSpacing * 4) - descHorzSpacing2 * 3, spacing + descriptionHeader + drawHeight, xmax - (descHorzSpacing * 4) - descHorzSpacing2 * 3, descriptionHeader)

    doc.setFontSize(12);

    doc.text(xmin + padding, ymin+grayRibbon+spacing-1.25, logInfo.jobNumber); //job number text

    //console.log(`client: ${logInfo.client}`)

    //trimStr = doc.splitTextToSize(logInfo.client + ' / ' + logInfo.project, (xday - xmin + xspacing - 2));

    //console.log(`trimStr: ${trimStr}`)

    //doc.text(xmin + xspacing / 2 + 1, ymin+grayRibbon+spacing - 1.25, client + ' / ' + project); //client text
    //doc.text(xmin + xspacing / 2 + 1, ymin+grayRibbon+spacing - 1.25, trimStr[0]); //client text

    doc.text(xmin + xspacing / 2 + 1, ymin+grayRibbon+spacing - 1.25, logInfo.client); //client text

    //console.log(`trimStr: ${trimStr}`)

    doc.text(xday + 1, ymin+grayRibbon + spacing - 1.25, dayName); //day text
    //doc.text((xmax - xday)/2 + xday + 1, ymin + grayRibbon + spacing - 1.25, formatDateYMD(logInfo.drillDate)); //date text
    doc.text((xmax - xday)/2 + xday + 1, ymin + grayRibbon + spacing - 1.25, logInfo.drillDate); //date text
    //doc.text(xmin + padding, ymin+grayRibbon+spacing*2-1.25, address + ', ' + city + ', ' + county + ' ' + state + ' ' + zip); //location text

    let address = logInfo.address === null ? '' : logInfo.address
    let city = logInfo.city === null ? '' : logInfo.city
    //state = logInfo.state === null ? '' : logInfo.state
    //zip = logInfo.zip === null ? '' : logInfo.zip

    //trimStr = doc.splitTextToSize(`${address}, ${city}, ${state} ${zip}`, (xspacing*2 - 2));
    trimStr = doc.splitTextToSize(`${address}, ${city}`, (xspacing*2 - 2));

    doc.text(xmin + padding, ymin+grayRibbon+spacing*2-1.25, trimStr[0]); //location text

    let lat = Number(logInfo.latitude)
    trimStr = doc.splitTextToSize(lat.toFixed(5), (xspacing - 2))
    doc.text(xmin + xspacing*2+1, ymin+grayRibbon+spacing*2-1.25, trimStr[0]) //latitude

    let lng = Number(logInfo.longitude)
    trimStr = doc.splitTextToSize(lng.toFixed(5), (xspacing - 2))
    doc.text(xmin + xspacing*2.66+1, ymin+grayRibbon+spacing*2-1.25, trimStr[0]) //longitude

    trimStr = doc.splitTextToSize(logInfo.elevation, (xspacing - 2))
    doc.text(xmin + xspacing*3.33+1, ymin+grayRibbon+spacing*2-1.25, trimStr[0]) //longitude

    trimStr = doc.splitTextToSize(logInfo.entryby, (xspacing - 2))
    doc.text(xmin + padding, ymin+grayRibbon+spacing*3-1.25, trimStr[0]) // logged by

    trimStr = doc.splitTextToSize(logInfo.driller, (xspacing - 2))
    doc.text(xmin + xspacing*1+1, ymin+grayRibbon+spacing*3-1.25, trimStr[0]) //driller

    trimStr = doc.splitTextToSize(logInfo.drillMethod, (xspacing - 2))
    doc.text(xmin + xspacing*2+1, ymin+grayRibbon+spacing*3-1.25, trimStr[0]) //drill method

    trimStr = doc.splitTextToSize(logInfo.drivingWeight, (xspacing - 2))
    doc.text(xmin + xspacing*3+1, ymin+grayRibbon+spacing*3-1.25, trimStr[0]) //driving weight

    // draw GW if exists

    if (logInfo.gw !== null) {

      if (logInfo.gw >= ftPerPage * (i-1) && logInfo.gw <= ftPerPage * i) {

        let gw = mmPerFoot * logInfo.gw

        let x = xmin + descHorzSpacing * 2 + descSpacing
        let y = drawHeightMin + gw - 3

        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.5)

        //doc.line(xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 / 2, drawHeightMin + gw, xmin + descHorzSpacing * 2 + descSpacing, drawHeightMin + gw - 3)

        //doc.line(xmin + descHorzSpacing * 2 + descSpacing, drawHeightMin + gw - 3, xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2, drawHeightMin + gw - 3)

        //doc.line(xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2, drawHeightMin + gw - 3, xmin + descHorzSpacing * 2 + descSpacing + descHorzSpacing2 / 2, drawHeightMin + gw)

        doc.triangle(x, y, x + descHorzSpacing2, y, x + descHorzSpacing2 / 2, y + 3, 'F')

        //black
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.25)

      }

    }

    // finish up footer

    doc.setFontSize(9);
    doc.setFont('times', 'bolditalic');
    doc.text(xmin, ymax + 4.5, '1011 North Armando Street, Anaheim CA 92806 (714) 630-1626');

    // plate
    doc.text(xmax, ymax + 4.5, `PLATE ${reportDetails.appendix}${Number(reportDetails.page) + Number(i)}`, 'right');

  }

  let blob = doc.output('blob')
  let device = getDeviceType()

  if (preview && (device === 'desktop' || device === 'electron')) {

    return URL.createObjectURL(blob)

  } else {

    let fileData = new FormData()
    fileData.append('filePath', 'logs')
    fileData.append('fileName', `log${logInfo.id}.pdf`)
    fileData.append('filePDF', blob)

    fetch('/api/uploadPDF', {
      method: 'post',
      body: fileData
    })
    .then(res=>res.json())
    .then(
      (result) => {
        //console.log('result: ' + JSON.stringify(result))

        return result

      },
      (error) => {

        alert('Error: could not upload Log. Contact and admin.')
        //catchError(data.jobNumber, data.gradeId, '', 'uploadDaily', JSON.stringify(error), user.username, user.device)
      }
    )

  }

}
